import { Component, h } from '@stencil/core';
import state from '@ugc-store';
import { MedalType } from '@ugc-components/ugc-pdp-review/interface';
import { modalZIndex } from '@ugc-utils/modal-z-index';
import { medalsMap } from '../medals-map';

@Component({
  tag: 'ugc-review-medal-modal',
  shadow: false,
})
export class UgcReviewMedalModal {
  render() {
    const {
      isShowMedalModal,
      reviewStaticLanguage: { IDS_LNK_CLOSE = '' } = {},
      medalModalData: { type = MedalType.Gold, title = '', description = '' },
    } = state;

    const medalsData = medalsMap.get(type);
    return (
      <ugc-modal-dialog
        isShow={isShowMedalModal}
        isShowCloseButton={false}
        zIndex={modalZIndex['ugc-review-medal-modal']}
        handleCancel={() => (state.isShowMedalModal = false)}
      >
        {isShowMedalModal && (
          <div class="pt-16 pb-24 px-24 rounded-4">
            <div class="flex-row-start-center gap-8">
              {medalsData.hoverIcon}
              <span class="mx-4 fs-20 color-gray-700 bold">{title}</span>
            </div>
            <p class="fs-16 lh-24 mt-12 mb-16 break-word color-gray-700">{description}</p>
            <ugc-button height="48" type="ghost" onClick={() => (state.isShowMedalModal = false)}>
              {IDS_LNK_CLOSE}
            </ugc-button>
          </div>
        )}
      </ugc-modal-dialog>
    );
  }
}
